export const moduleId = 'rates';
